import { useGetAllSystemColorsSuspense } from "@/orval/gen"
import { useMantineColorScheme } from "@mantine/core"

/// <summary>
/// Hook to get all system colors with a stale time of 20 minutes.
/// </summary>
export function useSystemColors() {
  const { data } = useGetAllSystemColorsSuspense({
    query: { staleTime: 20 * 60 * 1000 },
  })
  const colorMap = new Map(
    data.map((color) => [color.color, color.hexValue ?? undefined])
  )

  return colorMap
}

interface SystemColors {
  Today: string | undefined
  Saturday: string | undefined
  Sunday: string | undefined
  Holiday: string | undefined
  SchoolHoliday: string | undefined
}
export function useColorSchemeSystemColors(): SystemColors {
  const { colorScheme } = useMantineColorScheme()
  const colors = useSystemColors()
  if (colorScheme === "dark") {
    return {
      Today: colors.get("TodayBackColorDark"),
      Saturday: colors.get("SaturdayBackColorDark"),
      Sunday: colors.get("SundayBackColorDark"),
      Holiday: colors.get("HolidayBackColorDark"),
      SchoolHoliday: colors.get("SchoolHolidaysBackColorDark"),
    }
  }
  return {
    Today: colors.get("TodayBackColor"),
    Saturday: colors.get("Saturday"),
    Sunday: colors.get("Sunday"),
    Holiday: colors.get("Holiday"),
    SchoolHoliday: colors.get("SchoolHolidaysBackColor"),
  }
}
